import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import SemanticModelsPage from "./ui/SemanticModelsPage";

/** Warehouse semantic layer editor — under Data Pipeline next to Adaptor Discovery. */
const SemanticModels = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <SemanticModelsPage />
    </PageContentShell>
  </DashboardLayout>
);

export default SemanticModels;
